import {Component, Input, OnChanges, OnInit, SimpleChanges, TemplateRef, ViewChild} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {EntityService} from "@signature-it/ngx-entity/services";
import {GenericConfig} from "@signature-it/ngx-generic/config";
import { ShareDataService as ShareDataServiceGeneric } from '@signature-it/ngx-generic/services';

export enum ItemType {
	IMAGE = 'Image',
	YOUTUBE = 'YouTube',
	DOCUMENT = 'Document',
	LINK = 'Link',
}

export enum ImageSize {
	ORIGINAL = 'original',
	SMALL = 'small',
	MEDIUM = 'medium',
	LARGE = 'large',
}

@Component({
    selector: 'ngx-entity-preview-media',
    templateUrl: './entity-preview-media.component.html',
    styleUrls: ['./entity-preview-media.component.scss'],
    standalone: false
})


export class EntityPreviewMediaComponent implements OnInit, OnChanges{
	@Input() type: string;
	@Input() src: string;
	@Input() alt: string = '';
	@Input() thumb: string;
	@Input() movieHeight: string = '100%';
	@Input() movieWidth: string = '100%';
	_openPopupOnClick = true;
	@Input() set openPopupOnClick(value){
		this._openPopupOnClick = value == 'true';
	}
	@Input() maId: number;
	@Input() maVar: string;
	@Input() align: string;
	@Input() size: string = ImageSize.ORIGINAL;
	@Input() border: boolean = false;
	@Input() rotateToLandscape: boolean = false;
	@Input() cdn: boolean = false;
	@Input() cdnStandartWidth: string;
	@Input() cdnStandartHeight: string;
	@Input() cdnSmallWidth: string;
	@Input() cdnEnlargeWidth: string;
	@Input() cdnQuality: string;
	@Input() showPreview: boolean = true;
	@Input() noImage: boolean = false;
	@Input() noImageSize: string = 'Med';
	@Input() device: string;
	config;
	inlineStyle: string = '';
	newOrientation: any = '';
	isRotate: boolean = false;
	srcEnlarge: string;
	showMedia:boolean = true;

	@ViewChild('dialogTmp', {static: false}) dialogTmp: TemplateRef<any>;

	constructor(
		public dialog: MatDialog,  protected entityService: EntityService, public sharedSvc: ShareDataServiceGeneric) {
		this.config = GenericConfig;
	}
	
	clickMedia(event){
		if(!this._openPopupOnClick) return;
		if(this.cdn && this.type == ItemType.IMAGE && !this.srcEnlarge) return;
		event.preventDefault();
		event.stopPropagation();
		if(this.type == ItemType.LINK) {
			window.open(this.src, '_blank');
		}else {
			this.dialog.open(this.dialogTmp);
		}
	}

	closeDialog() {
		this.dialog.closeAll();
	}

	ngOnInit(): void {

		if((!this.type || !this.src) && (this.maId || this.maVar)){
			this.entityService.getMediaAssetData(this.maId?this.maId:this.maVar).subscribe(
				res => {
						if(res && res[0])
						{
							this.type = res[0]['image_type'];
							switch (this.type){
								case ItemType.YOUTUBE:
									this.src = 'https://www.youtube.com/embed/' + res[0]['file_path'];
									this.thumb = 'http://img.youtube.com/vi/' + res[0]['file_path'] +'/hqdefault.jpg';
									return;
								case  ItemType.IMAGE:
									this.src = `${res[0]['file_path']}/${res[0]['filename_display']}`;
									return;
								case  ItemType.LINK:
									this.src = res[0]['link_url'];
									return;
								case  ItemType.DOCUMENT:
									this.src = `${this.config.beURL}/${res[0]['file_path']}/${res[0]['filename_display']}`;
									return;
							}
						}
				});
		}else if(this.type == ItemType.YOUTUBE && !this.thumb){
	    	let video_id = this.src.split('v=')[1]?.split('&')[0];
			if(!video_id) video_id = this.src.split('embed')[1]?.split('/')[1];
			this.src = 'https://www.youtube.com/embed/' + video_id;
			this.thumb = 'http://img.youtube.com/vi/' + video_id +'/hqdefault.jpg';
		}
		if (this.border) {
			this.inlineStyle += 'border: 1px solid black;';
		}
		if (this.size && this.size != ImageSize.ORIGINAL) {
			switch (this.size) {
				case ImageSize.SMALL:
					this.inlineStyle += 'width: 200px';
					break;
				case ImageSize.MEDIUM:
					this.inlineStyle += 'width: 350px';
					break;
				case ImageSize.LARGE:
					this.inlineStyle += 'width: 500px';
					break;
			}
		}
		if((this.sharedSvc.isMobileMode() && this.device == 'desktop') || (!this.sharedSvc.isMobileMode() && this.device == 'mobile')) {
			this.showMedia = false;
		}
	}

	ngOnChanges(changes: SimpleChanges) {
		if (this.type == ItemType.IMAGE && this.cdn && this.src && GenericConfig.cdn ){
			let paramUrl, paramUrlEnlarge = '';
			if(this.cdnStandartHeight){
				paramUrl = 'height=' + this.cdnStandartHeight;
			}
			if (this.cdnSmallWidth){
				paramUrl += ',width=' + this.cdnSmallWidth;
			} else if (this.cdnStandartWidth){
				paramUrl += ',width=' + this.cdnStandartWidth;
			}
			if (this.cdnQuality){
				paramUrl += ',quality=' + this.cdnQuality;
			}
			if (this.cdnEnlargeWidth){
				paramUrlEnlarge = 'width=' + this.cdnEnlargeWidth;
				if (this.cdnQuality){
					paramUrlEnlarge += ',quality=' + this.cdnQuality;
				}
			}
			if (paramUrlEnlarge) {
				this.srcEnlarge = GenericConfig.cdn + paramUrlEnlarge + this.src;
			}
			if (paramUrl){
				this.src = GenericConfig.cdn + paramUrl + this.src;
			}
		}
	}

	getOppositeOrientation() {
		return screen
			.orientation
			.type
			.startsWith("portrait") ? "landscape" : "portrait";
	}

	async rotate() {
		if (!document.fullscreenElement) {
			await document.documentElement.requestFullscreen();
		}
		this.newOrientation = this.getOppositeOrientation();
		await screen.orientation['lock'](this.newOrientation);
		this.isRotate = !this.isRotate;
		if (this.isRotate) {
			this.dialog.open(this.dialogTmp, {backdropClass: 'backdropFullScreenDialog'});
		} else {
			await document.exitFullscreen();
			this.dialog.closeAll();
		}
	}
}

